import {
  faPersonRunning, faPersonBiking, faPersonSwimming, faPersonHiking, faPersonWalking,
  faDumbbell, faBolt, faPersonSkiing, faMountain, faOm, faWater, faFutbol,
  faTableTennisPaddleBall, faRotate, faPersonSkating, faGolfBallTee, faMedal,
  faTrophy, faArchive, faCoins, faBed, faCrown, faLayerGroup, faFire, faCalendar,
  faSuitcase, faBullseye, faHeart, faBatteryQuarter, faList, faCubes, faClock,
  faPersonPraying,
} from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const SPORT_ICON: Record<string, IconDefinition> = {
  Run:            faPersonRunning,
  TrailRun:       faPersonRunning,
  VirtualRun:     faPersonRunning,
  Treadmill:      faPersonRunning,
  Ride:           faPersonBiking,
  VirtualRide:    faPersonBiking,
  MountainBikeRide: faPersonBiking,
  GravelRide:     faPersonBiking,
  EBikeRide:      faPersonBiking,
  EMountainBikeRide: faPersonBiking,
  Swim:           faPersonSwimming,
  OpenWaterSwim:  faPersonSwimming,
  Hike:           faPersonHiking,
  Walk:           faPersonWalking,
  Snowshoe:       faPersonHiking,
  WeightTraining: faDumbbell,
  Workout:        faDumbbell,
  Crossfit:       faDumbbell,
  Yoga:           faPersonPraying,
  Pilates:        faDumbbell,
  Stretching:     faDumbbell,
  Elliptical:     faRotate,
  NordicSki:      faPersonSkiing,
  Skiing:         faPersonSkiing,
  Snowboard:      faPersonSkiing,
  AlpineSki:      faPersonSkiing,
  IceSkate:       faPersonSkating,
  Rowing:         faWater,
  Kayaking:       faWater,
  Canoeing:       faWater,
  Surfing:        faWater,
  Soccer:         faFutbol,
  Tennis:         faTableTennisPaddleBall,
  Golf:           faGolfBallTee,
  RockClimbing:   faMountain,
  Consolation:    faArchive,
  Betting:        faCoins,
  RestDay:        faBed,
  ChallengeKing:  faCrown,
  Multisport:     faLayerGroup,
  SportJunky:     faFire,
  DailySpin:      faCalendar,
  BadgeReward:    faSuitcase,
  // Badge-Icons
  faBullseye:     faBullseye,
  faHeart:        faHeart,
  faBatteryQuarter: faBatteryQuarter,
  faList: faList,
  faCubes: faCubes,
  faClock: faClock,
  faSuitcase:     faSuitcase,
};

const SPORT_ICON_DEFAULT: IconDefinition = faMedal;

export function getSportIcon(sportType: string): IconDefinition {
  return SPORT_ICON[sportType] ?? SPORT_ICON_DEFAULT;
}
